// extracted by mini-css-extract-plugin
module.exports = {"header":"Title-module__header___1R4cg","title":"Title-module__title___20EX0"};